export const API = {
    // BASE_URL:  'https://devapis.zupzap.com/v1/' , ----------> Development Url
    BASE_URL:  'https://apis.zupzap.com/v1/' ,
}